import { useState, useEffect } from 'react'

function BannerCookies() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const aceptado = localStorage.getItem('cookies_aceptadas')
    if (!aceptado) setVisible(true)
  }, [])

  function aceptar() {
    localStorage.setItem('cookies_aceptadas', 'true')
    setVisible(false)
  }

  function rechazar() {
    localStorage.setItem('cookies_aceptadas', 'false')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div style={estilos.banner}>
      <div style={estilos.contenido}>
        <p style={estilos.texto}>
          Usamos cookies técnicas necesarias para el funcionamiento del servicio.
          No usamos cookies publicitarias.{' '}
<span onClick={() => { window.location.href = '/privacidad' }} style={{...estilos.link, cursor: 'pointer'}}>Más información</span>
        </p>
        <div style={estilos.botones}>
          <button onClick={rechazar} style={estilos.btnRechazar}>
            Solo esenciales
          </button>
          <button onClick={aceptar} style={estilos.btnAceptar}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  )
}

const estilos = {
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#2C1810',
    borderTop: '1px solid #3D2418',
    zIndex: 1000,
    padding: '16px 24px',
  },
  contenido: {
    maxWidth: '1100px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '24px',
    flexWrap: 'wrap',
  },
  texto: {
    color: '#C4A882',
    fontSize: '14px',
    lineHeight: '1.6',
    flex: 1,
    margin: 0,
  },
  link: {
    color: '#FAF8F5',
    textDecoration: 'underline',
  },
  botones: {
    display: 'flex',
    gap: '12px',
    flexShrink: 0,
  },
  btnAceptar: {
    backgroundColor: '#C4A882',
    color: '#2C1810',
    border: 'none',
    padding: '10px 24px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  btnRechazar: {
    backgroundColor: 'transparent',
    color: '#C4A882',
    border: '1px solid #8B6F47',
    padding: '10px 24px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
  },
}

export default BannerCookies
